const Popup = {
  init() {
    $('[data-popup]').on('click', function (e) {
      e.preventDefault();
      const target = $(this).data('popup');

      $(`.popup[data-id="${target}"]`).addClass('open');
    });

    // On esc close popup
    $(document).keyup(function (e) {
      if (e.keyCode === 27 && $('.popup').hasClass('open')) {
        $('.popup').removeClass('open');
      }
    });

    // close on click close button
    $('.popup__close').on('click', function () {
      $('.popup').removeClass('open');
    });

    // Close popup if clicked outside .popup__box
    $('.popup').on('click', function (e) {
      if (e.target !== this) return;
      $(this).removeClass('open');
    });

    // Close popup
    $('.lang-box select').on('change', function () {
      $('.popup').removeClass('open');
    });
  },
};

export default Popup;
